var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dialog)?_c('v-dialog',{attrs:{"fullscreen":_vm.current_location === 'fullscreen'},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('IndeDialogCard',{attrs:{"disabled":_vm.disabled}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }